import { isFunction } from "./function.js";
export function getLazy(value, ...args) {
    return isFunction(value) ? value(...args) : value;
}
